import { createContext, useContext, useEffect, useState } from "react";
import { api, getToken, setToken } from "./api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [authed, setAuthed] = useState(!!getToken());
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const t = getToken();
    if (!t) {
      setAuthed(false);
      setLoading(false);
      return;
    }
    api
      .get("/auth/me")
      .then(() => setAuthed(true))
      .catch(() => {
        setToken(null);
        setAuthed(false);
      })
      .finally(() => setLoading(false));
  }, []);

  const login = async (password) => {
    const { data } = await api.post("/auth/login", { password });
    setToken(data.token);
    setAuthed(true);
    return data;
  };

  const logout = () => {
    setToken(null);
    setAuthed(false);
  };

  return (
    <AuthCtx.Provider value={{ authed, loading, login, logout }}>
      {children}
    </AuthCtx.Provider>
  );
}

export function useAuth() {
  const ctx = useContext(AuthCtx);
  if (!ctx) throw new Error("useAuth outside AuthProvider");
  return ctx;
}
